
export default {
    name: "GridBlok",
    props: {
        blok: {
            type: Object,
            required: true,
        },
    },
}
